import styled from "styled-components";

export const ErrorWrapper = styled.div`
  position: absolute;
  height: 100vh;
  height: -webkit-fill-available;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.lightgrey03};
`;

export const ErrorContent = styled.div`
  text-align: center;
  padding: 0 35px;

  h2 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 16px;
    color: ${(props) => props.theme.black};
  }

  p {
    font-size: 16px;
    color: ${(props) => props.theme.black50};
    margin-bottom: 24px;
  }
`;
